import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';
import { CirclePlusIcon } from 'views/ui/icons';
import { Remove2 } from 'views/ui/icons/anyfont-icons';
import { Button } from 'ui_system/token_auth/elements/Button';
import { colors } from 'ui_system/compass';
import { PencilIcon } from 'views/ui/icons/anyfont-icons/Pencil';

interface RemoveButtonProps {
  isprimary: boolean;
}

interface NameTagProps {
  capitalize: boolean;
}

interface DesktopOptionWrapperProps {
  islast: boolean;
}

export const RemoveIcon = styled(Remove2)`
  opacity: ${(props) => (props.isprimary ? '0.2' : '1')};
  height: 20px;
  width: 20px;
`;

export const EditIcon = styled(PencilIcon)`
  opacity: 1;
  height: 20px;
  width: 15px;
`;

export const AddIcon = styled(CirclePlusIcon)`
  height: 24px;
  width: 24px;
`;

export const AddGuestWrapper = styled.div`
  padding-top: 19px;
  display: flex;
  cursor: pointer;
  width: 100%;
  @media (max-width: ${Theme.mobile.phoneWidth}px) {
    padding: 20px 10px;
    border-top: 1px solid ${colors.border};
  }
`;

export const AddGuestText = styled.span`
  color: ${colors.primary};
  margin-left: 5px;
  @media (max-width: ${Theme.mobile.phoneWidth}px) {
    margin-top: 3px;
  }
`;

export const MobileHeader = styled.div`
  height: 60px;
`;

export const GuestOptionsWrapper = styled.div`
  padding: 0 12px;
  border: 1px solid ${colors.borderAction};
  border-radius: 0;
  background-color: ${colors.white};
`;

export const DesktopOptionWrapper = styled.div<DesktopOptionWrapperProps>`
  padding: 6px;
  border-bottom: 1px solid ${colors.border};
  border-bottom: ${(props) =>
    props.islast ? 'none' : `1px solid ${colors.border}`};
`;

export const TicketIdText = styled.span`
  font-size: 12px;
  color: ${colors.text.secondary};
`;

export const GuestName = styled.span<NameTagProps>`
  display: inline-block;
  font-size: 16px;
  ${(props) => props.capitalize && 'text-transform: capitalize'};
`;

export const PrimaryText = styled.span`
  display: inline-block;
  font-size: 12px;
  background: ${colors.border};
  border-radius: 6px;
  padding: 2px 6px;
  color: ${colors.text.placeholder};
  margin-left: 10px;
`;

export const GuestNameWrapper = styled.div``;
export const PriceWrapper = styled.div`
  font-size: 14px;
  color: ${colors.text.secondary};
`;
export const PriceBreakDown = styled.span``;

export const EditButton = styled.button`
  border: none;
  background-color: transparent;
  display: inline-block;
  width: 60px;
  opacity: 1;
  margin-left: -10px;
`;

export const EditSection = styled.div`
  display: flex;
  @media (max-width: ${Theme.mobile.phoneWidth}px) {
    display: flex;
    border-left: 1px solid ${colors.border};
    padding-left: 10px;
  }
`;

export const RemoveButton = styled.button<RemoveButtonProps>`
  border: none;
  background-color: transparent;
  cursor: ${(props) => (props.isprimary ? 'not-allowed' : 'pointer')};
  display: inline-block;
  width: 60px;
  opacity: ${(props) => (props.isprimary ? '0.2' : '1')};
`;

export const RemoveSection = styled.div`
  display: flex;
  @media (max-width: ${Theme.mobile.phoneWidth}px) {
    display: flex;
    border-left: 1px solid ${colors.border};
    padding-left: 10px;
  }
`;

export const ControlSectionWrapper = styled.div`
  display: flex;
  float: right;
  font-size: 13px;
  color: #3d57ff;
  @media (max-width: ${Theme.mobile.phoneWidth}px) {
    margin-top: 15px;
    padding: 5px;
    font-size: 13px;
    color: ${colors.primary};
  }
`;

export const MobileMainWrapper = styled.div`
  padding: 0 12px;
  border-radius: 0;
  background-color: ${colors.white};
  text-align: left;
  border-top: 1px solid ${colors.border};
  padding-bottom: 35px;
  &:last-child {
    border-bottom: 1px solid ${colors.border};
  }
`;

export const MobileOptionWrapper = styled.div`
  padding: 12px;
  border-bottom: 1px solid ${colors.border};
`;

export const DoneButtonContainer = styled.div`
  border-top: 1px solid ${colors.border};
  margin: auto;
  top: 95%;
  right: 0;
  left: 0;
  width: 342px;
  height: 44px;
  margin-top: 75px;
  margin-bottom: 50px;
`;

export const DoneButton = styled(Button)`
  background-color: ${colors.primary};
  margin: 24px 0px;
  color: ${colors.white};
  font-size: 17px;
  line-height: 22px;
`;

export const TicketDescriptionText = styled.span`
  font-size: 14px;
  color: ${colors.text.secondary};
`;
